import isProd from '../constants/isProd'

const partsInBasket = isProd
    ? window.basket_parts_quantity_by_hash
    : { c8bfdadfb7f61f94c157c7a12c137a8f: { basket_id: 100500, quantity: 2 } }

export default partsInBasket
